export function getRequest(input, init) {
    return input instanceof Request ? input : new Request(input, init);
}
